// extracted by mini-css-extract-plugin
export default {"EachQ":"ForumQuestionList_EachQ__TUCKQ"};